var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IconWithTooltip',{attrs:{"icon":_vm.icon,"color":_vm.color,"tooltip-analytics-name":_vm.tooltipAnalyticsName}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }